export const CACHE_DEVICE_ID = 'x-sh-device-id' // 设备id
export const CACHE_WORKSPACE_KEY = 'x-sh-wkey' // workspace key
export const CACHE_API_NOTICE = 'x-api-notice' // api收费提醒
export const CACHE_HIDE_SMALL_AMOUNT = 'hide-small-amount-'
export const TIME_ZONE = 'time_zone-' // 时区存储
const cacheUtil = {
  get(key: string, jsonfy = false) {
    const res = localStorage.getItem(key)
    if (res && jsonfy) {
      return JSON.parse(res)
    }
    return res
  },

  set(key: string, value: any, stringfy = false) {
    if (stringfy) {
      value = JSON.stringify(value)
    }
    localStorage.setItem(key, value)
  },
  clear() {
    localStorage.clear()
  },
}

export default cacheUtil
